import React from 'react';

const ORDER = ['red', 'amber', 'green'];

/** Red/amber/green tally for a rated document. */
const FindingsStrip = ({ counts, variant = 'strip' }) => {
  const totals = counts ?? { red: 0, amber: 0, green: 0 };

  return (
    <div className={`findings-strip findings-strip--${variant}`}>
      {ORDER.map((color) => (
        <span key={color} className={`findings-strip__item findings-strip__item--${color}`}>
          <span className="findings-strip__dot" aria-hidden="true" />
          <span className="findings-strip__count">{totals[color] ?? 0}</span>
        </span>
      ))}
    </div>
  );
};

export default FindingsStrip;
